import React from 'react';
import styled from 'styled-components';

import api from '../../../common/api/api';

const StyledDiv = styled.div`
  width: 100%;
  height: 100%;
  overflow: hidden;
  /* set similar iframe border */
  border: 2px inset;
  iframe {
    border: 0;
    width: 100%;
    /* hide msoffice viewer header and fill up remaining height space */
    height: calc(100% + 91px);
    margin-top: -91px;
  }
`;

export interface MSOfficeLiveViewerProps {
  title: string;
  url: string;
  className?: string;
}

const MSOfficeLiveViewer: React.FC<MSOfficeLiveViewerProps> = props => {
  const { title, url, className } = props;
  const proxyUrl = new URL('files/view', api.getBaseUrl());
  proxyUrl.searchParams.append('src', url);
  return (
    <StyledDiv>
      <iframe title={title} src={proxyUrl.href} className={className} />
    </StyledDiv>
  );
};

export default MSOfficeLiveViewer;
